/**
 * (c) 2022, Nous Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
import commonSizes from "./common-sizes";

const space = {
  ...commonSizes,
};

export default space;
